import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';

// Kiezer voor objecten: categorie kiezen, zoeken, aanklikken.
// Geeft de gekozen ids terug via onChange.
export default function ObjectKiezer({ waarde = [], onChange }) {
  const [categorieen, setCategorieen] = useState([]);
  const [categorie, setCategorie] = useState('');
  const [zoek, setZoek] = useState('');
  const [resultaten, setResultaten] = useState([]);
  const [laden, setLaden] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    api.get('/wo-objecten/categorieen')
      .then(r => setCategorieen(r.data?.categorieen || []))
      .catch(() => setCategorieen([]));
  }, []);

  const zoeken = useCallback((cat, q) => {
    if (!cat && !q) { setResultaten([]); return; }
    setLaden(true);
    api.get('/wo-objecten/zoek-objecten', { params: { categorie: cat || undefined, q: q || undefined } })
      .then(r => setResultaten(r.data?.objecten || []))
      .catch(() => setResultaten([]))
      .finally(() => setLaden(false));
  }, []);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => zoeken(categorie, zoek), 250);
    return () => { if (timer.current) clearTimeout(timer.current); };
  }, [categorie, zoek, zoeken]);

  const gekozenIds = waarde.map(o => o.id);

  const kies = o => {
    if (gekozenIds.includes(o.id)) return;
    onChange([...waarde, o]);
  };
  const verwijder = id => onChange(waarde.filter(o => o.id !== id));

  const rij = {
    padding: '9px 10px', borderTop: '1px solid #e2e8f0',
    display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer',
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <select value={categorie} onChange={e => setCategorie(e.target.value)}
          style={{ flex: '0 0 40%' }}>
          <option value="">— Alle categorieën —</option>
          {categorieen.map(c => (
            <option key={c.categorie} value={c.categorie}>
              {c.categorie} ({c.aantal})
            </option>
          ))}
        </select>
        <input type="text" value={zoek} onChange={e => setZoek(e.target.value)}
          placeholder="Zoek op nummer of straat" style={{ flex: 1 }} />
      </div>

      {(categorie || zoek) && (
        <div style={{
          border: '1px solid #e2e8f0', borderRadius: 8,
          maxHeight: 210, overflowY: 'auto', marginBottom: 8,
        }}>
          {laden && <div style={{ padding: 10, fontSize: 13, color: '#64748b' }}>Zoeken…</div>}
          {!laden && resultaten.length === 0 && (
            <div style={{ padding: 10, fontSize: 13, color: '#64748b' }}>Niets gevonden.</div>
          )}
          {!laden && resultaten.map(o => {
            const al = gekozenIds.includes(o.id);
            return (
              <div key={o.id} onClick={() => kies(o)}
                style={{ ...rij, opacity: al ? 0.45 : 1, cursor: al ? 'default' : 'pointer' }}>
                <span style={{ fontWeight: 600, minWidth: 74 }}>{o.naam}</span>
                <span style={{ flex: 1, fontSize: 13, color: '#475569' }}>
                  {[o.adres, o.plaats].filter(Boolean).join(', ')}
                </span>
                {!o.heeft_coords && (
                  <span style={{ fontSize: 11, color: '#f59e0b' }}>geen locatie</span>
                )}
                <span style={{ fontSize: 13, color: al ? '#64748b' : '#2563eb' }}>
                  {al ? 'gekozen' : '+ kies'}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {waarde.length > 0 && (
        <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
            {waarde.length} gekozen
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {waarde.map(o => (
              <span key={o.id}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  background: '#f1f5f9', borderRadius: 6, padding: '4px 8px', fontSize: 13,
                }}>
                {o.naam}
                <span onClick={() => verwijder(o.id)}
                  style={{ cursor: 'pointer', color: '#64748b', fontWeight: 700 }}>×</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
